<div class="container">
    <div class="my-4" *ngIf="documentoVistaPrevia != ''">
        <div class="alert alert-success" role="alert">
            Codigo QR valido.
        </div>

        <ngx-extended-pdf-viewer [base64Src]="documentoVistaPrevia" [useBrowserLocale]="true" [enablePrint]="false"
            [showOpenFileButton]="false" [showDownloadButton]="false" [showPropertiesButton]="false"
            [showBookmarkButton]="false" [showPropertiesButton]="false" [showSecondaryToolbarButton]="false"
            height="90vh" [zoom]="'100%'" backgroundColor="#e8e8ef"></ngx-extended-pdf-viewer>
    </div>
</div>